import { useLanguage } from '@contexts/LanguageContext';

export const useFileUtils = (file, imageTimestamp, thumbnailSize) => {
    const { t } = useLanguage();

    const getFileUrl = (getThumbnailUrl = false) => {
        if (!file) return '';

        const apiUrl = process.env.REACT_APP_API_URL;

        // If thumbnail size is specified and we have thumbnails for images
        if (getThumbnailUrl && thumbnailSize && isImage()) {
            const thumbnailKey = `h${thumbnailSize}`;
            const pathParts = file.file_path.split('.');
            const extension = pathParts.pop();
            const basePath = pathParts.join('.');
            const file_pathWithsuffix = `${basePath}-${thumbnailKey}.${extension}`;
            return `${apiUrl}/api/files/serve/${file_pathWithsuffix}?t=${imageTimestamp}`;
        }

        // Fallback to original file
        return `${apiUrl}/api/files/serve/${file.file_path}?t=${imageTimestamp}`;
    };

    // Get file URL without timestamp for crop operations (to avoid CORS issues)
    const getFileUrlForCrop = () => {
        if (!file) return '';

        const apiUrl = process.env.REACT_APP_API_URL;
        return `${apiUrl}/api/files/serve/${file.file_path}`;
    };

    const isImage = () => {
        return file?.mime_type && file.mime_type.startsWith('image/');
    };

    const isPDF = () => {
        return file?.mime_type === 'application/pdf';
    };

    const formatFileSize = (bytes) => {
        if (bytes === 0) return t('attachments.fileSize.zero');
        const k = 1024;
        const sizes = [
            t('attachments.fileSize.bytes'),
            t('attachments.fileSize.kb'),
            t('attachments.fileSize.mb'),
            t('attachments.fileSize.gb')
        ];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    const getFileIcon = () => {
        if (isImage()) return 'image';
        if (isPDF()) return 'file-pdf';
        return 'file-alt';
    };

    const getFileType = () => {
        if (isPDF()) return 'PDF';
        return file?.filename.split('.').pop()?.toUpperCase() || t('attachments.file');
    };

    return {
        getFileUrl,
        getFileUrlForCrop,
        isImage,
        isPDF,
        formatFileSize,
        getFileIcon,
        getFileType
    };
};
